import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';
import Row from 'react-bootstrap/Row';
import LykioButton from '../common/LykioButton';
import t from "../../Utils/Translation";

import {
	AUTHORIZED_URL_PREFIX,
	AxiosConfig,
    UPDATE_SETTINGS_URL,
    NOTIFICATION_SEVERITY_SUCCESS
} from '../../Utils/Constants';

function Welcome() {

    const handleHideVideoAtStartup = async () => {
        try {
          const { data } = await axios.post(
            `${AUTHORIZED_URL_PREFIX}${UPDATE_SETTINGS_URL}`,
            { hideVideoAtStartup: true, changeSettingsFromHome: true },
            AxiosConfig()
          );
          if (data.success) {
            notify({
              title: `${t("You will not see this page on your next login!")}`,
              severity: NOTIFICATION_SEVERITY_SUCCESS,
              creationDate: ''
            });
          }
        } catch (error) {
          console.log(error);
          notify(pleaseRefreshError);
        }
      };

    return ( <div className="lykioccs-main-content lykiocss-home">
        <div style={{ minWidth: "20em", minHeight: "25em", margin:'2em' }}>
        <h4>WELCOME!</h4>
        <div className="lykiocss-center">
            <video controls className="lykiocss-center" src={localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Video+introduttivo+ITA.mp4" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Video+introduttivo+ENG.mp4"}
              poster="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/intro_cover.png"
              style={{borderRadius:'15px', maxWidth: '46em'}}></video>
        </div>
          <p style={{marginTop:"1em"}}>
            {t("The selection interview is a critical moment for any organization. Research has shown that unconscious biases are one of the factors that most strongly influence the evaluations made in selection and recruitment, often leading to errors in judgment. To address this issue, we have designed a program that enables selection professionals to deepen their understanding of biases and their impact on decision-making processes. This program will help you acquire the necessary skills to manage diversity and make informed choices when recruiting new team members.")}
          </p>
          <p>
            {t("The platform allows you to:")}
            <ul>
              <li>{t("explore the topic of biases and the underlying mechanisms of the mind that influence decision-making processes.")}</li>
              <li>{t("engage in dialogue with virtual candidates and practice avoiding potentially discriminatory questions.")}</li>
              <li>{t("refine your assessment skills by engaging in multi-candidate selection sessions, blind screening, and evaluator evaluations.")}</li>
              <li>{t("assess your knowledge of bias in evaluation by taking quizzes and solving riddles")}</li>
            </ul>
          </p>
          <p>
            {t("After each activity, you will receive detailed feedback and an invitation to continue on a personalized learning path. Keep in mind that feedback is confidential; it's entirely your choice whether or not to disclose it. Start playing, share your experience with colleagues, play the activities as many time as you want to improve your performance, track your progress, and let us know your favorite content. Additionally, you can post news and information that you think might be of interest to others.")}
          </p>
          <p>
          {t("Choose one of the activities in the menu above to start")}
          </p>
    </div>

    <Row style={{marginLeft:'1em'}}>
      <LykioButton
        style={{display: 'inline-block', width: "22em", marginLeft: '1em', maxHeight:"4em"}}
        id="showIntro"
        variant="light"
        onClick={() => handleHideVideoAtStartup()}
      >
        {t("Do not show this page again")}
      </LykioButton>
    </Row>
    
    </div> );
}

export default Welcome;